export default __webpack_public_path__ + "static/media/SF-Pro-Display-Regular.d1f5e6e1.otf";